import { connect } from 'react-redux'
import PastTripsLogs from '../../components/trips/trip-detail/PastTripsLogs'
import { IStoreState, IRiderTrip } from '../../types'
import * as actions from '../../state/actions/trips'
import { actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import moment from 'moment'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const pastTrips = ownProps.pastTrips
  return {
    pastTrips
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    cloneTrip: async (trip: IRiderTrip) => {
      const tripClone = { ...trip }
      const pickup = {
        lat: tripClone.pickupLocation.latitude,
        lng: tripClone.pickupLocation.longitude,
        address: tripClone.pickupLocation.fullAddress,
        placeName: tripClone.pickupLocation.placeName
      }
      const dropoff = {
        lat: tripClone.dropoffLocation.latitude,
        lng: tripClone.dropoffLocation.longitude,
        address: tripClone.dropoffLocation.fullAddress,
        placeName: tripClone.dropoffLocation.placeName
      }
      tripClone.product = { id: '', name: '', pricingId: '' }
      tripClone.rider = undefined
      tripClone.scheduledPickupTime = moment().toISOString()
      tripClone.scheduledDropoffTime = undefined

      return Promise.all([
        dispatch(actions.actionCreators.cloneTrip(tripClone)),
        dispatch(mapsActionCreators.setOrigin(pickup)),
        dispatch(mapsActionCreators.setDestination(dropoff)),
        dispatch(
          mapsActionCreators.replaceMarkers('origin', [
            {
              type: 'origin',
              lat: pickup.lat,
              lng: pickup.lng
            }
          ])
        ),
        dispatch(
          mapsActionCreators.replaceMarkers('destination', [
            {
              type: 'destination',
              lat: dropoff.lat,
              lng: dropoff.lng
            }
          ])
        )
      ])
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PastTripsLogs)



// WEBPACK FOOTER //
// ./src/containers/trips/PastTripsLogs.ts